import { FormattedMessage } from "react-intl";

import { ButtonProps, Button } from "ui/Button/Button";

import { usePickingActions } from "../hooks/usePickingActions";

type GoToScanContainersButtonProps = { isButtonDisabled?: boolean } & ButtonProps;

export function GoToScanContainersButton({
  isButtonDisabled = false,
  ...rest
}: GoToScanContainersButtonProps) {
  const { goToScanContainers } = usePickingActions();

  return (
    <Button
      isDisabled={isButtonDisabled}
      onClick={() => goToScanContainers()}
      size="lg"
      isFullWidth
      data-testid="redirect-to-scan-containers-button"
      {...rest}
    >
      <FormattedMessage id="components.picking.go-to-scan-containers-button.button-label-scan-containers" />
    </Button>
  );
}
